import { useTranslation } from "react-i18next";

import { Link, Arrange } from "@aviary";
import { emersonRoutes } from "@emerson/data/emersonRoutes";
import { l } from "@emerson/locales/i18n";

import { SidebarMenu } from "../SidebarMenu/SidebarMenu";

const Education = () => {
  const { t } = useTranslation();

  return (
    <SidebarMenu title={t(l.header.Education.Header)}>
      <Arrange isVertical isFullWidth>
        <Link
          href={emersonRoutes.external.education.blog}
          isColor="system"
          isUnderLined={false}
          isHoverUnderLined={false}
          noExternalIcon
        >
          {t(l.header.Education.Blog)}
        </Link>
        <Link
          href={emersonRoutes.external.education.academy}
          isColor="system"
          isUnderLined={false}
          isHoverUnderLined={false}
          noExternalIcon
        >
          {t(l.header.Education.FSAcademy)}
        </Link>
        <Link
          href={emersonRoutes.external.education.resources}
          isColor="system"
          isUnderLined={false}
          isHoverUnderLined={false}
          noExternalIcon
        >
          {t(l.header.Education.PracticeResources)}
        </Link>
      </Arrange>
    </SidebarMenu>
  );
};

export { Education };
